import { getFullMobileUiLocales } from '@/i18n';
import { ConfigProvider } from 'antd-mobile';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type LocaleProviderProps = {
  children: ReactNode;
};

export function LocaleProvider(props: LocaleProviderProps) {
  const { children } = props;
  const { i18n } = useTranslation();

  const { antMobileLocale } = getFullMobileUiLocales(i18n.language);

  return <ConfigProvider locale={antMobileLocale}>{children}</ConfigProvider>;
}
